
import {permission } from '@/api/user'

const state = {
  menus:''
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.menus = routes
  }
}

const actions = {
  generateRoutes({ commit }) {
    return new Promise(resolve => {
     
      permission().then(response =>{
        // console.log(response)
        const { result } = response
        commit('SET_ROUTES', result)
        resolve(result)
      })
     
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
